import { HeaderCellProps } from '../types';

export const TeamMembersHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Active Members</div>;
};
